
/**
 * extracts image filename
 * @param str absolute path to the image obtained from API
 * @returns image filename
 */
const getFileName = function (str:any) {
    return str.split('\\').pop().split('/').pop();
}

/**
 * creates path to the image
 * @param path absolute path to the image obtained from API (from which just the file name is extracted)
 * @returns path to the file that goes through SYMLINK (IMAGES) in BLOGS folder that leads to the IS storage
 */
export const setImage = (path:any) => {
    let srcAttribute = process.env.PUBLIC_URL + '/blogs/images/' + getFileName(path);
    return srcAttribute;
}